/**
 * Device names that should be filtered out from MIDI device lists.
 * Network Session is an iOS artifact that appears when MIDI network sessions
 * are enabled, but we don't want to expose it to users.
 */
const IGNORED_DEVICE_NAMES = ["Network Session 1", "Session 1"];

export function isIgnoredMidiDevice(name: string): boolean {
  return IGNORED_DEVICE_NAMES.includes(name);
}
